import { render } from "./TasksOverviewChart.vue?vue&type=template&id=cf1808e8&ts=true"
import script from "./TasksOverviewChart.vue?vue&type=script&lang=ts"
export * from "./TasksOverviewChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__